import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import WifiTetheringIcon from "@material-ui/icons/WifiTethering";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Visibility from "@material-ui/icons/Visibility";
import Delete from "@material-ui/icons/Delete";
import SyncIcon from "@material-ui/icons/Sync";
import Room from "@material-ui/icons/Room";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const classes = useStyles();
  const {
    tableHead,
    tableData,
    tableHeaderColor,
    createConfirm,
    handleEdit,
    setGeoLocation,
    createConfirmSync,
    stylesLockers,
    role,
    iconView,
  } = props;

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.map((prop, key) => {
            let {
              id,
              name,
              status,
              appVersion,
              geolocation,
              group_lockers,
              ocupationRate,
              cond,
              whatsapp,
              mode,
            } = prop;
            let statusColor = [];
            let currentMode = "Em operação";
            let newMode = " - ";
            let currentSattus = (
              <div className="locker-align-icons-text">
                <WifiTetheringIcon color="secondary" />
                <div>Offline</div>
              </div>
            );

            switch (status) {
              case "active":
                currentSattus = (
                  <div className="locker-align-icons-text">
                    <WifiTetheringIcon style={{ color: "#4caf50" }} />
                    <div>Online</div>
                  </div>
                );
                statusColor.push("tableBodyRowActive");
                break;
              case "inactive":
                // currentMode = "Inativo";
                statusColor.push("tableBodyRowInactive");
                break;
              case "installing":
                currentMode = "Em ativação";
                statusColor.push("tableBodyRowInstalling");
                break;
              default:
                currentMode = "Em manutenção";
                statusColor.push("tableBodyRowMaintance");
                break;
            }

            switch (mode) {
              case "active":
                newMode = "Em operação";
                break;
              case "inactive":
                newMode = "Inativo";
                break;
              case "installing":
                newMode = "Em ativação";
                break;
              case "maintenance":
                newMode = "Em manutenção";
                break;
              default:
                newMode = "Em operação";
                break;
            }

            let whatsappField = whatsapp ? (
              <div style={{textAlign: "center"}}>
                <WhatsAppIcon style={{ color: "#4caf50" }} />
              </div>
            ) : (
              <div className="locker-align-icons-text">
                {/* <CancelIcon style={{ color: "#f50057" }} /> */}
              </div>
            );

            return (
              <TableRow key={key} className={classes.tableBodyRow}>
                <TableCell className={classes.tableCell} key={`${key}-name`}>
                  {name}
                </TableCell>
                <TableCell className={classes.tableCell} key={`${key}-cond`}>
                  {cond}
                </TableCell>
                {/* <TableCell
                  className={classes.tableCell}
                  key={`${key}-currentMode`}
                >
                  {currentMode}
                </TableCell> */}
                <TableCell className={classes.tableCell} key={`${key}-newMode`}>
                  {newMode}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  key={`${key}-whatsappField`}
                >
                  {whatsappField}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  key={`${key}-currentSattus`}
                >
                  {currentSattus}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  key={`${key}-ocupationRate`}
                >
                  {`${ocupationRate}%`}
                </TableCell>
                <TableCell className={classes.tableCell} key={`${key}-tool`}>
                  <div>
                    <Tooltip title="Localização georreferenciada do Locker no mapa">
                      <IconButton onClick={() => setGeoLocation(geolocation)}>
                        <Room />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Visão e operação dos compartimentos, encomendas, configurações, usuários, operações e eventos do Locker">
                      <IconButton
                        onClick={() => handleEdit(id, name)}
                        aria-label="view"
                      >
                        <Visibility className={iconView} />
                      </IconButton>
                    </Tooltip>

                    {role !== "Administrador" ? (
                      ""
                    ) : (
                      <>
                        <Tooltip title="Sync Locker">
                          <IconButton
                            onClick={() => createConfirmSync(id, name)}
                            aria-label="view"
                          >
                            <SyncIcon className={iconView} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Deletar Locker">
                          <IconButton
                            onClick={() => createConfirm(id, name)}
                            aria-label="view"
                          >
                            <Delete className={iconView} />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "white",
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "white",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object),
  tableBodyRow: PropTypes.arrayOf(PropTypes.string),
};
